module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429998314_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Characters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "21.98*"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "9.89*"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "68.13*"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MAN")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "rowspan": "3",
      "valign": "middle"
    }
  }, [_c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429998314_i0003.jpg",
      "height": "113px",
      "src": "e9781429998314_i0003.jpg",
      "width": "27px"
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WOMAN")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Three people in their thirties")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CODY")])]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WAITRESS")]), _vm._v(" A woman in her twenties")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad647910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429998314_c01.vue
// module id = 72
// module chunks = 0